import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { CalendarService } from '../../../services/calendar.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ngx-set-date-legal-requirement',
  templateUrl: './set-date-legal-requirement.component.html',
  styleUrls: ['./set-date-legal-requirement.component.scss'],
})
export class SetDateLegalRequirementComponent implements OnInit {
  @Input() stationId: string;
  @Input() requirement: any;
  @Input() dependenceId: string;

  date: any = new Date();
  loading: boolean = false;
  constructor(
    protected ref: NbDialogRef<SetDateLegalRequirementComponent>,
    private calendarService: CalendarService,
  ) { }

  ngOnInit() {
  }

  async setDate() {
    if (this.date) {
      this.loading = true;
      const data: any = { dependence_id: this.dependenceId, date: moment(this.date).format('YYYY-MM-DD'), parent: true }
      if (
        this.requirement.requirement || this.requirement.legal_requirement_requirement_id || this.requirement.pivot
      ) data.requirement_id = this.requirement.legal_requirement_requirement_id || this.requirement.pivot.legal_requirement_requirement_id || this.requirement.requirement.id
      else data.custom_requirement_id = this.requirement.id
      const [error] = await this.calendarService.storeDeliverable(this.stationId, data);
      if (error) {
        this.loading = false;
        return this.ref.close(false);
      }
      this.loading = false;
      this.alert('Exito', 'success', 'Se programo el requisito legal');
      return this.ref.close(true);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Selecciona un fehca',
        text: '',
      });
    }

  }

  async alert(title: string = 'asdasd', icon: SweetAlertIcon = 'success', text: string = '', html: string = '') {
    await Swal.fire({ icon, title, text, html });
  }

}
